export default "__VITE_ASSET__2ZEzIIM_atdpHcr$6kvj$Q__ 480w, __VITE_ASSET__nJkgIVJgL11RgZiGUBj6wA__ 768w, __VITE_ASSET__U6muqRGa8aHtq8t0c9wAzg__ 1200w";